import React, { useCallback, useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { IconButton, Paper, styled, Collapse, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Menu, MenuItem, Chip, MenuList, Typography, Button } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { format, formatRelative, max, min } from 'date-fns';
import useAnimationFrame from '../../hooks/useAnimationFrame';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import type { GeoJsonFeature } from '../../utils/ogc';
import useThrottledValue from '../../hooks/useThrottledValue';
import { SPEEDS } from '../../config';




const TimeScrubberControls = ({ timeRange, currentTime, onTimeChange, onTimeRangeChange, children, controls, hideDatePicker, playing, setPlaying }: {
  timeRange: [Date, Date, boolean];
  currentTime: Date;
  onTimeChange: (newTime: Date | ((prevTime: Date) => Date)) => void;
  onTimeRangeChange: (newRange: [Date, Date]) => void;
  children?: React.ReactNode;
  hideDatePicker?: boolean;
  playing: boolean;
  setPlaying: (playing: boolean) => void;
}) => {
  const [fromTime, toTime, live] = timeRange;
  const liveCursor = live && (currentTime == toTime);
  // console.log('liveCursor', liveCursor, live, currentTime, fromTime, toTime);

  const timeEnabled = !!currentTime;
  const [speedFactor, setSpeedFactor] = React.useState(1000 * 60 * 30);

  useAnimationFrame({
    playing: playing && timeEnabled,
    interval: 80,
    onTimeChange: (deltaMs) => {
      onTimeChange((t: Date) =>  {
        const ti = t||fromTime;
        if (!ti?.getTime) console.log("BAD TIME", t, fromTime);
        if (!ti?.getTime) return ti;
        const next = new Date(ti.getTime() + (deltaMs * speedFactor) / 1000)
        return next > toTime ? fromTime : next
      })
    }
  })

  
  // useEffect(() => {
  //   if (playing && !timeEnabled) {
  //     setPlaying(false);
  //   }
  // }, [playing, timeEnabled, setPlaying]);

  // const togglePlay = useCallback(() => setPlaying((p: boolean) => !p), [setPlaying]);
  const togglePlay = useCallback(() => setPlaying(!playing), [playing, setPlaying]);
  // return
  // local edit buffers so typing doesn't immediately commit
  // const fmt = (d: Date) => new Date(d).toISOString().slice(0, 16)
  // const [fromStr, setFromStr] = React.useState<string>(fmt(fromTime))
  // const [toStr, setToStr] = React.useState<string>(fmt(toTime))

  // React.useEffect(() => {
  //   setFromStr(fmt(fromTime))
  // }, [fromTime])
  // React.useEffect(() => {
  //   setToStr(fmt(toTime))
  // }, [toTime])

  // const commitFrom = React.useCallback(() => {
  //   const d = new Date(fromStr)
  //   if (!isNaN(d.getTime())) onTimeRangeChange([d, toTime])
  // }, [fromStr, toTime, onTimeRangeChange])
  // const commitTo = React.useCallback(() => {
  //   const d = new Date(toStr)
  //   if (!isNaN(d.getTime())) onTimeRangeChange([fromTime, d])
  // }, [toStr, fromTime, onTimeRangeChange])

  // const onKeyCommit = (e: React.KeyboardEvent<HTMLInputElement>, which: 'from' | 'to') => {
  //   if (e.key === 'Enter') {
  //     if (which === 'from') commitFrom();
  //     else commitTo();
  //     (e.target as HTMLInputElement).blur()
  //   }
  // }

  const onSliderChange = useCallback((e: Event, val: number | number[]) => {
    if (typeof val === "number") {
      onTimeChange(new Date(val));
      setPlaying(false);
    }
  }, [onTimeChange, setPlaying]);
  const onSliderChangeCommitted = useCallback((e: React.SyntheticEvent | Event, val: number | number[]) => {
    if (typeof val === "number") {
      const date = new Date(val);
      onTimeChange(date >= toTime ? true : date);
    }
  }, [onTimeChange, toTime]);

  return (<>
      <Box sx={{ overflowX: 'visible', width: '100%', userSelect: 'none' }}>
          <StyledSlider
            min={new Date(fromTime).getTime()}
            max={new Date(toTime).getTime()}
            value={new Date(currentTime).getTime()}
            // valueLabelFormat={v => format(new Date(v), 'HH:mm aaa')}
            valueLabelDisplay="off"
            onChange={onSliderChange}
            onChangeCommitted={onSliderChangeCommitted}
            color={liveCursor ? 'error' : 'primary'}
            sx={{
            '& .MuiSlider-track': {
              transition: playing ? 'none !important' : undefined,
            },
            '& .MuiSlider-thumb::after': {
              width: 32
            },
            }}
            // slotProps={{ track: { style: { transition: playing ? 'none !important' : undefined }, sx: { transition: playing ? 'none !important' : undefined } } }}
          />
          <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: -2,
          }}>
          <StartEndText timeRange={timeRange} />
        </Box>
        </Box>

      <Box display="flex" justifyContent={liveCursor ? 'center' : 'space-between'} alignItems="center" alignSelf='stretch' gap={1} flexWrap="wrap">
        {liveCursor ? null : <PlayPauseButton playing={playing} onToggle={togglePlay} />}
        {controls}
        {liveCursor ? null : <CuteSelect tooltip="Playback speed" value={speedFactor} options={SPEEDS} onSelect={setSpeedFactor} />}

      {/* {!hideDatePicker && <>
        <input
          type="datetime-local"
          value={fromStr}
          onChange={e => setFromStr(e.target.value)}
          onBlur={commitFrom}
          onKeyDown={(e) => onKeyCommit(e, 'from')}
        />
        <span> to </span>
        <input
          type="datetime-local"
          value={toStr}
          onChange={e => setToStr(e.target.value)}
          onBlur={commitTo}
          onKeyDown={(e) => onKeyCommit(e, 'to')}
        />
        </>} */}
      </Box>
      {children}
  </>)
}
export default React.memo(TimeScrubberControls);




const PlayPauseButton = React.memo(({ playing, onToggle }: { playing: boolean; onToggle: () => void }) => {
  return (
    <IconButton size='small' onPointerDown={onToggle} aria-label={playing ? "Pause" : "Play"} sx={{ outline: 'none', p: 0.4 }}>
      {playing ? <PauseIcon /> : <PlayArrowIcon />}
    </IconButton>
  )
});


const StartEndText = React.memo(({ timeRange }: { timeRange: [Date, Date] }) => {
  const [fromTime, toTime] = timeRange;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', px: 0 }}>
      <TinyText>{format(fromTime, 'MMM dd, yyyy HH:mm')}</TinyText>
      <TinyText>{format(toTime, 'MMM dd, yyyy HH:mm')}</TinyText>
    </Box>
  )
});


const CuteSelect = React.memo(({ value, options, onSelect, tooltip }: { value: string | number; options: Array<{ value: string | number; label: string }>; onSelect?: (value: string | number) => void; tooltip?: string }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const onOpen = React.useCallback((e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget), []);
  const onSelectItem = React.useCallback((v: string | number) => {
    setAnchorEl(null);
    onSelect?.(v);
  }, [onSelect]);
  const onClose = React.useCallback(() => setAnchorEl(null), []);
  const label = options?.find((o: any) => o.value === value)?.label || value;
  return (<>
    <Tooltip title={tooltip || ""}>
    <Chip size='small' label={label} onClick={onOpen} />
    </Tooltip>
    <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        sx={{ p: 0, '& .MuiList-root': { p: 0, pt: 0, pb: 0 } }}
      >
        <MenuList dense sx={{ p: 0, pt: 0, pb: 0 }}>
        {options?.map((o: any) => (
          <MenuItem key={o.value} selected={o.value === value} onClick={() => onSelectItem(o.value)} sx={{ px: 0.5 }}>
            {o.label}
          </MenuItem>
        ))}
        </MenuList>
      </Menu>
  </>)
})


const StyledSlider = styled(Slider)({
  // boxSizing: 'border-box',
  // height: '4px',
  height: '0.5em',
  padding: '10px 0 !important',
  '& .MuiSlider-thumb': {
    width: 6,
    height: 0,
    borderRadius: 6,
    transition: 'height 0.2s ease',
  },
  '&:hover .MuiSlider-thumb': {
    height: 12,
  },
});

const TinyText = styled(Typography)({
  fontSize: '0.75rem',
  opacity: 0.38,
  fontWeight: 500,
  letterSpacing: 0.2,
});
